/** Completed years from a YYYY-MM-DD date of birth, using the calendar date as entered. */
export function ageFromDateOfBirth(isoDate: string, asOf: Date = new Date()): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec((isoDate || '').trim());
  if (!match) return '';
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return '';

  let age = asOf.getFullYear() - year;
  const monthDelta = asOf.getMonth() + 1 - month;
  if (monthDelta < 0 || (monthDelta === 0 && asOf.getDate() < day)) {
    age -= 1;
  }
  if (!Number.isFinite(age) || age < 0 || age > 30) return '';
  return String(age);
}
